export default "__VITE_ASSET__CJw6Fx4Y__"